<template>
  <div class="bg-[#FFFFFF]">
    <div
      class="w-100 bg-[#F8F8F8] border border-2 text-black p-1 rounded-t-xl font-semibold"
    >
      Catatan Perubahan Email & Nomor Hp
    </div>
    <div class="border border-2 p-1 rounded-b-xl mb-2">
      <BRow>
        <BCol lg="6">
          <div class="border border-2 rounded-xl mb-2 p-1">
            <div
              class="text-black mb-2"
            >
              Perubahan Email :
            </div>
            <div
              v-if="logsChanged.email_log && logsChanged.email_log.length > 0"
              class="overflow-y-auto h-[6rem] text-black mt-[5px] overflow-auto"
            >
              <div
                v-for="(item, index) in logsChanged.email_log"
                :key="index"
                class="bg-[#F8F8F8] rounded-[10px] p-[12px] mb-[6px]"
              >
                <div class="d-flex align-items-center gap-[8px] text-sm mb-[8px]">
                  <span class="text-black">{{ item.old_value || '-' }}</span>
                  <span>→</span>
                  <span class="text-black">{{ item.new_value }}</span>
                </div>
                <div class="d-flex align-items-center flex-nowrap gap-[8px] text-sm text-gray-400">
                  {{ DAY_MONTH_YEAR(item.created_at) }}, {{ TIME(item.created_at) }} WIB
                  <span v-if="item.user_action !== ''"> • Diubah oleh: <span class="text-black">{{ item.user_action }}</span></span>
                </div>
              </div>
            </div>
            <div
              v-else
              class="h-[3rem] text-black text-center"
            >
              Tidak Ada Perubahan
            </div>
          </div>
        </BCol>
        <BCol lg="6">
          <div class="border border-2 rounded-xl mb-2 p-1">
            <div
              class="text-black mb-2"
            >
              Perubahan Nomor HP :
            </div>
            <div
              v-if="logsChanged.phone_log && logsChanged.phone_log.length > 0"
              class="overflow-y-auto h-[6rem] text-black mt-[5px] overflow-auto"
            >
              <div
                v-for="(item, index) in logsChanged.phone_log"
                :key="index"
                class="bg-[#F8F8F8] rounded-[10px] p-[12px] mb-[6px] w-max min-w-[100%]"
              >
                <div class="d-flex align-items-center gap-[8px] text-sm mb-[8px]">
                  <span>{{ item.old_value ? (item.old_value.startsWith('0') ? item.old_value : `0${item.old_value}`) : '-' }}</span>
                  <span>→</span>
                  <span class="text-black">{{ item.new_value.startsWith('0') ? item.new_value : `0${item.new_value}` }}</span>
                </div>
                <div class="d-flex align-items-center flex-nowrap gap-[6px] text-sm text-gray-400 whitespace-nowrap">
                  <span>{{ DAY_MONTH_YEAR(item.created_at) }},
                    {{ TIME(item.created_at) }} WIB</span>
                  <span
                    v-if="item.user_action !== ''"
                    class="d-flex align-items-center gap-[6px]"
                  >
                    <span>•</span>
                    <span> Diubah oleh: <span class="text-black">{{ item.user_action }}</span></span>
                    <template v-if="item.action_type === 'admin'">
                      <span>•</span>
                      <a
                        :href="item.supporting_link"
                        target="_blank"
                        class="text-[#F95031]"
                        style="display: inline-flex !important; align-items: center; white-space: nowrap;"
                      >
                        Lihat Dokumen
                        <img
                          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/export.svg"
                          alt="export"
                          class="w-[12px] ml-[4px]"
                        >
                      </a>
                    </template>
                  </span>
                </div>
              </div>
            </div>
            <div
              v-else
              class="h-[3rem] text-black text-center"
            >
              Tidak Ada Perubahan
            </div>
          </div>
        </BCol>
      </BRow>
    </div>
    <div class="">
      <div class="w-100 bg-[#F8F8F8] border border-2 text-black p-1 rounded-t-xl font-semibold d-flex justify-between">
        <span class="align-self-center">Catatan Penambahan Nomor Rekening</span>
        <b-button
          variant="primary"
          @click="$bvModal.show('modal-add-rekening')"
        >
          + Tambah Rekening
        </b-button>
      </div>
      <div class="border border-2 rounded-b-xl mb-2 p-1">
        <div
          v-if="logsChanged.rekening_log && logsChanged.rekening_log.length > 0"
          class="overflow-y-auto h-[6rem] text-black mt-[5px] overflow-auto"
        >
          <div
            v-for="(item, index) in logsChanged.rekening_log"
            :key="index"
          >
            <span class="p-[5px]">{{ index + 1 }}.</span>
            <span class="mr-[5px]">{{ item.new_value }}</span>
            <span class="mr-[5px]">-</span>
            <span>{{ DAY_MONTH_YEAR(item.created_at) }} Pukul
              {{ TIME(item.created_at) }} WIB</span>
            <span v-if="item.user_action !== ''">
              <span> by {{ item.user_action }} </span>
              <a
                :href="item.supporting_link"
                target="_blank"
                class="text-[#08A0F7]"
              > Lihat Dokumen </a>
            </span>
          </div>
        </div>
        <div
          v-else
          class="h-[6rem] text-black text-center"
        >
          Tidak Ada Perubahan
        </div>
      </div>
    </div>
    <ModalAddRekening @on-confirm-button="updateBank" />
    <ModalPIN
      id="modal-pin-add-rekening"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Konfirmasi Perubahan?"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Batal"
      @on-confirm-button="verifiedPin"
    />
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import { DAY_MONTH_YEAR, TIME } from '@/libs/filterDate'
import ModalAddRekening from './ModalAddRekening.vue'

export default {
  components: { ModalAddRekening, ModalPIN },
  props: {
    logsChanged: {
      type: Object,
      default: () => null,
      required: true,
    },
  },
  data() {
    return {
      DAY_MONTH_YEAR,
      TIME,
      params: {
        user_id: Number(this.$route.params.id),
        pin: 0,
        bank_code: '',
        bank_no: '',
        bank_owner_name: '',
        supporting_link: '',
      },
    }
  },
  methods: {
    updateBank(newVal) {
      this.params.bank_code = newVal.bank_code
      this.params.bank_no = newVal.bank_no
      this.params.bank_owner_name = newVal.bank_owner_name
      this.params.supporting_link = newVal.supporting_link
      this.$bvModal.show('modal-pin-add-rekening')
    },
    async verifiedPin(newVal) {
      this.params.pin = Number(newVal)
      const url = 'auth/api/v1/admin/user/add-bank-account'
      try {
        const res = await newAxiosIns.post(url, this.params)
        this.$toast_success({ message: 'Sukses Melakukan Penambahan Rekening' })
        this.$emit('update-user-data')
      } catch (error) {
        this.$toast_error({ message: error.response.data.meta.message })
      }
    },
  },
}
</script>

<style scoped>
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
